
import React, { Fragment, memo, useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { PATH } from "utils/constants";
// import { PAGENAME } from "utils/constants";
import styles from "./HomeLayout.module.scss";
// import Button from "../../components/Button";
import { useNavigate } from "react-router-dom";
// import arrow from "assets/png/arrow.png";
import toast from "components/shared/toast/toast";
import Button from "components/shared/button/Button";
import { privatePost } from "services/privateRequest";
import { LOGOUT } from "services/apiEndpoints";
import { useDispatch, useSelector } from "react-redux";
import Image from "components/shared/Image/Image";

//image imports 
import logout from "assets/png/logout.png";
import profilePic from "assets/png/profile-icon.png"
import notificationIcon from "assets/svg/notification-icon.svg"
import { ReactComponent as PlusIcon } from "assets/svg/plus-icon.svg"
import { ReactComponent as LeftArrow } from "assets/svg/arrow-left.svg"
import { ReactComponent as MenuIcon } from "assets/svg/menu.svg"
import { ReactComponent as MoreIcon } from "assets/svg/more-vertical.svg"
import { setSidebarOpen } from "@redux/slices/homeSlice";
import { setLogoutModalOpen, setuserProfile } from "@redux/slices/globalSlice";

const TopBar = () => {
  const [logoutModel, setLogoutModel] = useState(false);
  const [currentPath, setCurrentPath] = useState({});
  const [unread, setUnread] = useState(true);
  const { id } = useParams()
  const { userDetailsPageName } = useSelector(state => state.userDetails)

  const { userProfile ,  logoutModalOpen, formName } = useSelector((state) => state.global);



  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const email = localStorage.getItem("email")
    ? localStorage.getItem("email")
    : "user@gmail.com";

  const backToPrevious = () => {
    navigate(-1)
  }

  const removeLastEndpoint = (str) => str.split("/").slice(0, -1).join("/")

  const pageName = useMemo(() => {
    let temp = {}
    const obj = Object.values(PATH.privateRoutes).find(pathData => {
      return (
        pathData.path === location.pathname
        ||
        (
          pathData.path.endsWith("Id")
          &&
          removeLastEndpoint(pathData.path) === removeLastEndpoint(location.pathname)
        )
      )
    })
    if (obj) {
      temp = obj
    }
    setCurrentPath(temp)
    return (temp?.pageName)
    // switch (pathName) {
    //   case PATH.BALANCE_SHEET || "/balance-generate":
    //     return PAGENAME.BALANCESHEET + " - Report Logs";

    //   case PATH.CASHFLOW_SHEET:
    //     return PAGENAME.CASHFLOWSHEET + " - Report Logs";

    //   case PATH.CONFIGURE:
    //     return PAGENAME.CONFIGURE;

    //   case PATH.BALANCE_GENERATE:
    //     return PAGENAME.BALANCESHEET + " - Report Logs";

    //   case PATH.CASHFLOW_GENERATE:
    //     return PAGENAME.CASHFLOWSHEET + " - Report Logs";

    //   default:
    //     break;
    // }
  }, [location]);

  const handleLogout = async () => {
    // await privatePost(LOGOUT)
    dispatch(setLogoutModalOpen(false));
    localStorage.clear()
    toast.success("Logout Successful")
    navigate("/login")
  };

  // const clearOnLogout = async(e) => {
  //   e.stopPropagation()
  //   try {
  //     await axios.get(LOGOUT, {
  //       headers: {
  //         Authorization: `Bearer ${getToken()}`
  //       }
  //     })
  //   }
  //   catch(err) {}
  //   finally {
  //     localStorage.clear();
  //     (currentRole === "user" Pmi|| currentRole === "approver") && localStorage.setItem(dontShowInstructionsKey, true)
  //     // dispatch(clear()) // uncomment this line if you want to clear redux store
  //     dispatch(clearAccounts())
  //     dispatch(setLogoutModalOpen(false))
  //     toast.success("Logged out successfully")
  //     navigate("/login")
  //   }
  // }

  const openSidebarForSmall = () => {
    dispatch(setSidebarOpen(true))
  }

  useEffect(() => {
    document.body.addEventListener("click", () => {
      setLogoutModel(false);
    });
  });

  return (

    <Fragment>
      <div className={styles.topBarContainer}>
        <div className={styles.leftSide}>
          <MenuIcon className={styles.menuIcon} onClick={openSidebarForSmall} />
          {userDetailsPageName || currentPath?.showBackIcon ? <LeftArrow className={styles.backIcon} onClick={backToPrevious} /> : ""}
          <p className={styles.pageName}>{pageName || userDetailsPageName || ""}</p>
        </div>

        <div className={styles.rightSide}>
          {/* {true && (
            <Button
              className={styles.generate}
              // onClick={() => navigate(location.pathname + "/generate")}
              // navigateTo={props?.navigateTo}
              label="Generate"
            />
          )} */}
          {/* <Button
            className={styles.generate}
            // onClick={() => navigate(location.pathname + "/generate")}
            // navigateTo={props?.navigateTo}
            label="Create"
          >
            <PlusIcon style={{width:"10px", paddingRight:"3px"}}/> Create
          </Button> */}

          {/* <div className={styles.notificationIconContainer}>
            <img className={styles.notificationIcon} src={notificationIcon} alt="notification icon" /> */}
            {/* {unread ? <div className={styles.unread}></div> : ""} */}
          {/* </div> */}

          <div className={styles.logoutCircle}>
            {/* <span
              onClick={(e) => {
                e.stopPropagation();
                setLogoutModel(!logoutModel);
              }}
              className={styles.firstLetter}
            >
              {email.charAt(0).toUpperCase()}
            </span> */}
            <Image
              className={styles.profilePic}
              src={userProfile}
              fallback={profilePic}
              alt="profile pic of the logged in user"
            />
            {/* <span className={styles.userName}>{email}</span> */}
            <span className={styles.userName}>{ email}</span>
            <MoreIcon
              className={styles.moreIcon}
              onClick={(e) => {
                // e.stopPropagation()
                dispatch(setLogoutModalOpen(!logoutModalOpen))
              }}
            />
            {logoutModalOpen && (
              <div className={styles.logoutModal} >
                <ul>
                  <li onClick={() => navigate("/settings")}>Profile Settings</li>
                  <li onClick={handleLogout}>Logout</li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* {logoutModel && (
        <div>
          <div className={styles.logoutButton}>
            <img className={styles.logoutIcon} src={logout} alt="logout" />
            <Button
              onClick={handleLogout}
              className={styles.logoutBtn}
              outline={true}
              label="Logout"
            />
          </div>
        </div>
      )} */}
    </Fragment>

  );
};

export default memo(TopBar);
